module.exports = ".body\r\n{\r\n    font-size: 13px;\r\n}"